import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewNewsModal = ({ id, data, title }) => {
    const NewsImageBaseUrl = process.env.REACT_APP_API_IMAGE_URL;
    const { isViewModalOpen, closeModal } = useContext(SidebarContext);
    const result = Array.isArray(data)
        ? data.find((item) => item.id === id)
        : data;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openZoomModal = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeZoomModal = () => {
        setSelectedImage(null);
        setIsModalOpen(false);
    };

    const renderImage = (image, i) => {
        return (
            <img style={{ width: "100%", height: "auto" }}
                className="inline-flex border rounded-md border-gray-100 dark:border-gray-600"
                src={NewsImageBaseUrl + (image || '-')}
                alt="Preview"
            />
        );
    };

    const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
   .custom-modal {
 
  overflow-y-auto; /* Enable scrolling if the content overflows */
}`;

    return (
        <>
            <style>{style}</style>
            <Modal
                className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-md"
                isOpen={isViewModalOpen}
                onClose={() => {
                    closeModal();
                }}
            >
                <ModalBody className="custom-modal">
                    <CommonCloseBtn onClose={closeModal}/>
                    <h2 className="text-center font-bold text-lg mb-4">
                        News Details
                    </h2>

                    <div className="p-4 max-h-96 overflow-auto">
                        <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5">
                            <dl className="text-sm dark:text-white">
                                {[
                                    { label: "Title", value: result?.title },
                                    { label: "Description", value: result?.description },
                                    { label: "News Url", value: result?.url },
                                ].map((item) => (
                                    <div
                                        key={item.label}
                                        className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4"
                                    >
                                        <dt className="font-medium text-gray-900 dark:text-white">
                                            {item.label}
                                        </dt>
                                        <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 break-words">
                                            {item.value || "-"}
                                        </dd>
                                    </div>
                                ))}


                            </dl>
                            <div style={{ display: "flex", alignItems: "center" }} className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">

                                <div style={{ width: "41%" }}>
                                    <dt className="font-medium text-gray-900 dark:text-white ">Image</dt>
                                </div>
                                <div style={{ width: "56%" }}>
                                    <dd
                                        className="text-gray-700 dark:text-white sm:col-span-2 cursor-pointer break-words"
                                        onClick={() => openZoomModal(NewsImageBaseUrl + (result?.news_image || '-'))}
                                    >
                                        {result?.news_image && renderImage(result.news_image||'-')}

                                    </dd>
                                </div>


                            </div>

                            {isModalOpen && (
                                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                                    <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                                        <button
                                            onClick={closeZoomModal}
                                            className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white"
                                        >
                                            <IoIosClose />
                                        </button>

                                        <img
                                            src={NewsImageBaseUrl + result?.news_image||'-'}
                                            alt={result?.title || "News Image"}
                                            className="w-full h-auto rounded-lg"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </ModalBody>

            </Modal>
        </>
    );
};

export default React.memo(ViewNewsModal);
